<template>
  <div>
    <el-divider content-position="left">お知らせ内容 (日本語)</el-divider>
    <div>
      <QuillEditor
        v-model:content="content_ja"
        contentType="html"
        theme="snow"
        :options="editorOptions"
      />
    </div>
    <el-divider content-position="left" editorStyle="height: 300px;"
      >お知らせ内容 (英語)</el-divider
    >
    <QuillEditor
      v-model:content="content_en"
      theme="snow"
      contentType="html"
      :options="editorOptions"
    />
    <el-divider />

    <!-- 保存按钮 -->
    <el-button type="primary" @click="confirmSave">保存</el-button>
  </div>
</template>

<script>
import { ref, onMounted } from "vue";
import { ElMessageBox, ElMessage } from "element-plus";
import { QuillEditor } from "@vueup/vue-quill"; // 使用 vueup/vue-quill
import "@vueup/vue-quill/dist/vue-quill.snow.css"; // Quill 样式
import { supabase } from "@/supabase.js"; // Supabase 连接
import { isEmpty } from "@/utils/utils.js";

export default {
  components: { QuillEditor },
  setup() {
    const content_ja = ref("");
    const content_en = ref("");
    // Quill 配置
    const editorOptions = ref({
      modules: {
        toolbar: [
          [{ header: [1, 2, 3, false] }],
          ["bold", "italic", "underline", "strike"], // 粗体、斜体、下划线、删除线
          [{ color: [] }, { background: [] }], // 🔥 颜色 & 背景颜色
          [{ list: "ordered" }, { list: "bullet" }], // 有序列表 & 无序列表
          [{ script: "sub" }, { script: "super" }], // 上标 & 下标
          [{ align: [] }], // 对齐方式
          ["link", "image", "video"], // 链接、图片、视频
          ["clean"], // 清除格式
        ],
      },
    });
    // 📌 从 Supabase 读取数据
    const fetchData = async () => {
      const { data, error } = await supabase
        .from("about_info_m")
        .select("name_ja, name_en")
        .eq("code", "usedpart")
        .single();

      if (error) {
        console.error("データ取得エラー:", error);
      } else {
        content_ja.value = data.name_ja;
        content_en.value = data.name_en;
      }
    };

    // 📌 保存数据
    const saveData = async () => {
      console.log("保存时的内容:", content_ja.value, content_en.value); // ✅ 确保值不为空
      if (isEmpty(content_ja.value) || isEmpty(content_en.value)) {
        ElMessage.error("内容を入力してください。");
        return;
      }

      const { error } = await supabase
        .from("about_info_m")
        .update({
          name_ja: content_ja.value,
          name_en: content_en.value,
        })
        .eq("code", "usedpart");

      if (error) {
        console.error("データ保存エラー:", error);
        ElMessage.error("保存に失敗しました。");
      } else {
        ElMessage.success("データを保存しました。");
      }
    };

    // 📌 确认保存对话框
    const confirmSave = () => {
      ElMessageBox.confirm("この内容で保存しますか？", "確認", {
        confirmButtonText: "保存",
        cancelButtonText: "キャンセル",
        type: "warning",
      })
        .then(() => {
          saveData();
        })
        .catch(() => {
          ElMessage.info("保存をキャンセルしました。");
        });
    };

    onMounted(fetchData);

    return {
      content_ja,
      content_en,
      confirmSave,
      editorOptions,
    };
  },
};
</script>

<style lang="stylus" scoped>
.el-divider >>> .el-divider__text {
  background-color: #f5f5f5 !important;
  color: var(--el-text-color-primary);
  font-size: 14px;
  font-weight: 500;
  padding: 0 20px;
  position: absolute;
}
</style>
